import moment from 'moment';
import _ from 'lodash';

/**
  GET Current Time
**/
export const dateFormat = (dateStr: string, dateFormat: string) => {
  if (!dateFormat) dateFormat = 'YYYY MM.DD';
  const dateSet = moment(dateStr).format(dateFormat);
  return dateSet;
};

export const dateFormatSet = (dateStr: string) => {
  const dateSet = moment(dateStr, 'YYYYMMDDHHmmss').format('YY.MM.DD HH:mm');
  return dateSet;
};
export const getDateMonth = (dateStr: string, format: string) => {
  const dateSet = moment(dateStr, format).format('MM');
  const ret = Number(dateSet);
  return ret;
};
export const getDateYear = (dateStr: string, format: string) => {
  const dateSet = moment(dateStr, format).format('YYYY');
  const ret = Number(dateSet);
  return ret;
};

export const getDateFormat = (dateStr: string, format: string) => {
  const dateSet = moment(dateStr, format).format('YYYY.MM.DD');
  return dateSet;
};

/**
  GET Current Time
**/
export const currentTime = () => {
  const timestamp = moment().format('YYYYMMDDHHmmss');
  return timestamp;
};
/**
  GET Current Time
**/
export const currentTimeFormat = (format = 'YYYY.MM.DD') => {
  const timestamp = moment().format(format);
  return timestamp;
};
/**
  GET Current Time
**/
export const currentFormatTime = (format: string, prevDate?: number) => {
  const now = moment();
  if (prevDate) {
    now.subtract(prevDate, 'days');
  }
  const timestamp = now.format(format);
  return timestamp;
};

/**
  dateFormat 
**/
export const dateFormatSeperType = (date: string) => {
  // const match = date.match(/\d{4}-(\d{2}-\d{2})/);
  const match = date.match(/\d{4}-(\d{2})-(\d{2})/);
  let retStr = '';
  if (match) {
    retStr = `${match[1]}.${match[2]}`;
  }
  return retStr;
};

/**
  dateFormat 
**/
export const dateCalendarFormatType = (date: string) => {
  if (!date) return date;
  const digits = date.replace(/\D/g, '').slice(0, 8);
  let retStr = digits.slice(0, 4);
  if (digits.length > 4) retStr += '.' + digits.slice(4, 6);
  if (digits.length > 6) retStr += '.' + digits.slice(6, 8);
  return retStr;
};

// 만 나이계산
export const getAge = (birthDate: string) => {
  const today = new Date();
  const birth = new Date(birthDate);

  let age = today.getFullYear() - birth.getFullYear();

  const isBeforeBirthday =
    today.getMonth() < birth.getMonth() ||
    (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate());

  if (isBeforeBirthday) {
    age--;
  }

  return age;
};

export const formatBirthSimple = (juminFront: any) => {
  const year = parseInt(juminFront.substring(0, 2), 10);
  const month = juminFront.substring(2, 4);
  const day = juminFront.substring(4, 6);

  const prefix = year > 30 ? '19' : '20'; // 기준 조정 가능

  return `${prefix}${juminFront.substring(0, 2)}-${month}-${day}`;
};
